var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22.75C18.3848 22.75 22.75 18.3848 22.75 13C22.75 7.61522 18.3848 3.25 13 3.25C7.61522 3.25 3.25 7.61522 3.25 13C3.25 14.7768 3.72529 16.4426 4.55566 17.8772L3.73564 20.9375C3.5198 21.7431 4.25692 22.4802 5.06245 22.2643L8.12278 21.4443C9.55738 22.2747 11.2232 22.75 13 22.75Z",
    fill: "#351083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCommunity);
export default __webpack_public_path__ + "static/media/active-community.866060fbd455b12e026d96e61f2dc4d4.svg";
export { ForwardRef as ReactComponent };